import { render, staticRenderFns } from "./VideosSection.vue?vue&type=template&id=4b8b5d0a&scoped=true&"
import script from "./VideosSection.vue?vue&type=script&lang=js&"
export * from "./VideosSection.vue?vue&type=script&lang=js&"
import style0 from "./VideosSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideosSection.vue?vue&type=style&index=1&id=4b8b5d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b5d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VPagination,VRow})
